package app.footyguide.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*

/**
 * Professional Lucide Icon component.
 * Uses CSS masks to allow the icon to inherit the current text color.
 */
@Composable
fun LucideIcon(
    name: String,
    size: Int = 20,
    color: String = "currentColor",
    className: String? = null
) {
    Span({
        classes("fg-icon")
        if (!className.isNullOrBlank()) classes(className)
        style {
            display(DisplayStyle.InlineBlock)
            width(size.px)
            height(size.px)
            property("mask-image", "url('/assets/icons/$name.svg')")
            property("-webkit-mask-image", "url('/assets/icons/$name.svg')")
            property("mask-repeat", "no-repeat")
            property("-webkit-mask-repeat", "no-repeat")
            property("mask-position", "center")
            property("-webkit-mask-position", "center")
            property("mask-size", "contain")
            property("-webkit-mask-size", "contain")
            backgroundColor(Color(color))
            property("vertical-align", "middle")
        }
    })
}

object Icons {
    const val SEARCH = "search"
    const val CHEVRON_DOWN = "chevron-down"
    const val CHEVRON_RIGHT = "chevron-right"
    const val SHIELD = "shield"
    const val CALENDAR = "calendar"
    const val TV = "tv"
    const val TROPHY = "trophy"
    const val ARROW_LEFT = "arrow-left"
    const val SHARE = "share-2"
    const val BELL = "bell"
}
